'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// yoinked from @scoir/rollup-plugins@1.0.6 getSvgId
var getSvgId = exports.getSvgId = function getSvgId(def) {
    return def.id;
};

var Icon = function Icon(_ref) {
    var def = _ref.def,
        _ref$size = _ref.size,
        size = _ref$size === undefined ? 'sm' : _ref$size,
        className = _ref.className,
        beforeText = _ref.beforeText,
        afterText = _ref.afterText,
        rest = _objectWithoutProperties(_ref, ['def', 'size', 'className', 'beforeText', 'afterText']);

    return _react2.default.createElement(
        'span',
        Object.assign({ className: (0, _classnames2.default)('scoir-icon', size, className, {
                'before-text': beforeText,
                'after-text': afterText
            })
        }, rest),
        _react2.default.createElement(
            'svg',
            null,
            _react2.default.createElement('use', { xlinkHref: '#' + getSvgId(def).replace('-usage', '') })
        )
    );
};

Icon.propTypes = {
    def: _propTypes2.default.shape({
        id: _propTypes2.default.string
    }).isRequired,
    size: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xlg']),
    className: _propTypes2.default.string,
    beforeText: _propTypes2.default.bool,
    afterText: _propTypes2.default.bool
};

Icon.defaultProps = {
    beforeText: false,
    afterText: false
};

exports.default = Icon;
//# sourceMappingURL=index.js.map